import React from 'react';
import ReactDOM from 'react-dom';
import ApexCharts from 'apexcharts';
import PropTypes from 'prop-types';
import App from './App';
import moment from 'moment-timezone';

moment.tz.setDefault('Asia/Kolkata');

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
